import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  LinearProgress,
  Modal,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { parseInt, startCase } from 'lodash';
import {
  activityList,
  addProgressToActivities,
  calculateWeightedAverageProgress,
  convertSelectedRowsToOldFormat,
  findPierAndTtByTrackerRowId,
  getChildrenOnly,
  getPartName,
  roundDown,
} from '../../shared/Helper';
import axiosInstance from '../../utils/axios';
import { useParams } from 'react-router-dom';
import { updateProgress } from '../../services/dashboard';
import { fetchTypeData, getConstructionProgressList } from '../../atoms/Dashboard/DashboardAtom';
import { useAtom } from 'jotai';
import TrackerTypeTable from './Mapview/TrackerTypeTable';
import StepperForm from './Mapview/StepperForm';
import CloseIcon from '@mui/icons-material/Close';
import setupAtoms from '../../atoms/setup/SetupAtoms';


const CardComponent = ({
  loader,
  progressList,
  construction,
  title,
  setCurrentSelection,
  checked,
  selectPart,
  setActivities,
  setActivityType,
  selectedRow,
  activity,
  projectBom,
  bomTrackerTypes,
  partTrackerTypes,
  blocks,
  trackerList,
  setSelectedRow,
  bulkAllData,
  pierlegends,
  setSection,
  setTracker,
  currentProject,
  setPartId,
  partList
}) => {
  const { id } = useParams()
  const [list, setList] = useState([]);
  const [percentage, setPercentage] = useState(0);
  const [active, setActive] = useState({});
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [current, setCurrent] = useState("");
  const params = useParams();
  const [open, setOpen] = useState(false);
  const [openSecondModal, setOpenSecondModal] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false)
  const blockName = blocks?.find((item) => item?.id === parseInt(params?.id))?.name;
  const [, setProgress] = useAtom(getConstructionProgressList);
  const [, setBlocks] = useAtom(fetchTypeData);
  const [markData, setMarkData] = useState({});
  const [partCount, setPartCount] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [editableDistributedRows, setEditableDistributedRows] = React.useState([]);
  const [editableInstalledRows, setEditableinstalledRows] = React.useState([]);
  const [selectedPier, setSelectedPier] = React.useState([]);
  const [selectedTt, setSelectedTt] = React.useState([]);
  const [finalData, setFinalData] = useState([]);
  const [currentTrackerRow, setCurrentTrackerRow] = useState('');
  const [activityData, setActivityData] = useState([]);
  const [load, setLoader] = useState(false);
  const [tempData] = useAtom(setupAtoms);
  const { SvgData } = tempData;

  function flattenTrackerData(data) {
    if (!data || typeof data !== 'object') return { table_coordinates: [], piers: [], tt: [] };

    const tableCoords = data.table_coordinates ?? {};
    const piers = data.piers ?? {};
    const tt = data.tt ?? {};

    const trackerId = Object.keys(tableCoords)?.[0];

    if (!trackerId) {
      return { table_coordinates: [], piers: [], tt: [] };
    }

    return {
      table_coordinates: tableCoords[trackerId] ?? [],
      piers: piers[trackerId] ?? [],
      tt: tt[trackerId] ?? []
    };
  }

  function flatNextTrackerData(data) {
    if (!data || typeof data !== 'object') return { piers: [], tt: [] };

    const piers = data.piers ?? {};
    const tt = data.tt ?? {};

    const trackerId = Object.keys(piers)?.[0];

    if (!trackerId) {
      return { piers: [], tt: [] };
    }

    return {
      piers: piers[trackerId] ?? [],
      tt: tt[trackerId] ?? []
    };
  }

  const flattenedTrackerData = React.useMemo(() => flattenTrackerData(SvgData), [SvgData]);
  const flattenedNextTrackerData = React.useMemo(() => flatNextTrackerData(SvgData), [SvgData]);

  const fetchCount = async (target) => {
    setLoading(true);
    try {
      let res
      if (id) {
        res = await axiosInstance.post(
          `progress/get_deployed_part_for_activity_in_block?block_id=${id}&activity_id=${target?.id}&part_id=${target?.part_id}`
        );
      } else {
        res = await axiosInstance.post(
          `progress/get_deployed_part_for_activity_in_block?activity_id=${target?.id}&part_id=${target?.part_id}`
        );
      }
      setData(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }


  const trackerTypeId = markData?.tracker_type_id;
  const partId = active?.target?.part_id;

  useEffect(() => {
    if (partId && trackerTypeId && partTrackerTypes) {
      const partKey = `${partId}_${trackerTypeId}`;
      const partCount = partTrackerTypes[partKey];
      setTotalCount(partCount);
    }
  }, [partId, trackerTypeId, partTrackerTypes]);


  useEffect(() => {
    if (construction) {
      const temp = activityList(construction);
      setList(addProgressToActivities(temp, progressList));
    }
  }, [construction, progressList]);

  useEffect(() => {
    if (list.length) {
      const children = getChildrenOnly(list);
      setPercentage(roundDown(calculateWeightedAverageProgress(children)));
    }
  }, [list]);

  const handleClick = async (key, index, label, data, id) => {
    const isSameSelection = key === active.key && index === active.index;

    if (isSameSelection) {
      setActive({});
      setCurrentSelection("");

      if (setSelectedRow) {
        setSelectedRow({
          count: null,
          sections: {},
          trackerTypes: {}
        });
      }
      if (setSection) setSection([]);
      if (setTracker) setTracker([]);

      setActivities("All");

      return;
    }

    const target = key === 'parent' ? data : data?.children?.[index];
    if (setPartId) {
      setPartId(target?.part_id)
    }
    setActivities(id)

    setCurrentSelection(label);
    let activityType = key === "parent" ? "parent_activity" : "sub_activity"
    if (setActivityType) {
      setActivityType(activityType)
    }

    setActive({ key, index, label, target, id });
    await fetchCount(target)
    if (params?.id) {
      await setBlocks(parseInt(params?.id), id);
    }
  };

  const getList = (value) => {
    if (value?.id) {
      return ["not_started", "in_progress", "completed"]
    } else {
      return ["not_started", "completed"]
    }
  }

  const handleSetCurrent = (event, value) => {
    event.stopPropagation();
    if(value === "in_progress") return

    if (current === value) setCurrent('')
    else setCurrent(value)
  }

  const getInstallValue = (id, value, section) => {
    if(value?.[`${id}_${section?.split('-')?.[2]}`]) {
      return value?.[`${id}_${section?.split('-')?.[2]}`]
    } else if(value?.[`${id}_${section?.split('-')?.[1]}_tr`]) {
      return value?.[`${id}_${section?.split('-')?.[1]}_tr`]
    } else {
      return 0
    }

  }

  const generateCount = (section, value, activityId, current) => {
    const id = section?.split('-')?.[2];

    const distributed = value?.distributed?.[activityId]?.map((item) => {
      return {
        bom_id: item?.bom_id,
        distributed_quantity: current === "completed" && currentProject?.type !== 1 ? bomTrackerTypes[`${item?.bom_id}_${id}`] : currentProject?.type === 1 ? getInstallValue(item?.bom_id, bomTrackerTypes, section) : 0 
      };
    }) || [];

    const installed = value?.installed?.[activityId]?.map((item) => {
      return {
        bom_id: item?.bom_id,
        installed_quantity: current === "completed" && currentProject?.type !== 1 ? bomTrackerTypes[`${item?.bom_id}_${id}`] : currentProject?.type === 1 ?getInstallValue(item?.bom_id, bomTrackerTypes, section) : 0
      };
    }) || [];


    return [...distributed, ...installed];
  };


  const handleClickApply = async (event, type, activities) => {
    event.stopPropagation();
    const sections = convertSelectedRowsToOldFormat(selectedRow);

    if (current === "in_progress") {
      setActivityData(activities)
      setEditableDistributedRows([])
      setEditableinstalledRows([])
      setPartCount(null)
      setOpen(!open);
      return;
    }

    setBtnLoader(true);

    const generateData = (items, activityIdResolver, data) =>
      items.flatMap((item) => {
        const activityId = activityIdResolver(item);
        const partId = item.part_id;
        return sections.map((section) => {
          const [, trackerRowIdStr, trackerTypeIdStr] = section?.split("-") || [];
          const trackerRowId = parseInt(trackerRowIdStr);
          const trackerTypeId = parseInt(trackerTypeIdStr);
          const partKey = `${partId}_${trackerTypeId}`;
          const partCount = partTrackerTypes[partKey];

          return {
            activity_id: activityId,
            block_id: params?.id,
            block_name: blockName,
            bom_per_tracker_type: generateCount(section, projectBom, activityId, current),
            completion_percentage: current === "completed" ? 100 : 0,
            deployed_part_count: current === "completed" ? partCount : 0,
            part_id: partId,
            status: current === "completed" ? 2 : 0,
            total_part_count: partCount,
            tracker_row_id: trackerRowId,
            tracker_type_id: trackerTypeId,
            laydown_id: data?.[trackerRowId]?.[0]?.["laydown_id"] ? data?.[trackerRowId]?.[0]?.["laydown_id"] : null,
          };
        });
      });

    const handleUpdate = async (data, activityData) => {
      try {
        const res = await updateProgress(parseInt(params?.id), data);
        if (res) {
          await fetchCount(activityData);
          await setProgress(parseInt(params?.id));
          await setBlocks(parseInt(params?.id), activityData?.id);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setBtnLoader(false);
      }
    };

    if (type === "parent_activity") {
      const items = [activities, ...(activities.children || [])];
      const data = generateData(items, (item) => item.id, bulkAllData?.piers);
      await handleUpdate(data, activities);
      setSelectedRow({
        count: null,
        sections: {},
        trackerTypes: {}
      })
      setCurrent(false)
      setSection([])
      setTracker([])
    } else {
      const data = generateData([{ part_id: construction[`${parseInt(activity)}`]?.part_id }], () => activity, bulkAllData?.piers);
      await handleUpdate(data, activities);
      setSelectedRow({
        count: null,
        sections: {},
        trackerTypes: {}
      })
      setCurrent(false)
      setSection([])
      setTracker([])
    }
  };

  const filterTrackerTypes = (trackerTypeIds, allTrackerTypes, selectedRow) => {

    return trackerTypeIds.map((item) => {
      const tracker_type_id = parseInt(item.split("_")[1]);
      const base = allTrackerTypes.find(t => t.tracker_type_id === tracker_type_id);
      const selectedCount = selectedRow?.trackerTypes?.[item]?.selectedCount ?? base?.count;
      return {
        ...base,
        count: selectedCount,
      };
    });
  }

  const handleSave = () => {
    const combinedRows = [
      ...editableDistributedRows.map(row => ({ ...row, type: 'distributed' })),
      ...editableInstalledRows.map(row => ({ ...row, type: 'installed' })),
    ];

    const trackerType = combinedRows.map(({ bom_id, distributed_quantities, installed_quantities, id, type }) => ({
      bom_id,
      id,
      ...(type === 'distributed'
        ? { distributed_quantity: distributed_quantities }
        : { installed_quantity: installed_quantities }),
    }));


    const selectedPierIndices = selectedPier.map(selectedPierItem => {
      return currentProject?.type === 1 ? flattenedTrackerData?.piers?.findIndex(refPier => refPier.id === selectedPierItem.id) : flattenedNextTrackerData?.piers?.findIndex(refPier => refPier.id === selectedPierItem.id);
    }).filter(index => index !== -1);

    const selectedTtIndices = selectedTt.map(selectedTtItem => {
      return currentProject?.type === 1 ? flattenedTrackerData?.tt?.findIndex(refPier => refPier.id === selectedTtItem.id) : flattenedNextTrackerData?.tt?.findIndex(refTt => refTt.id === selectedTtItem.id);
    }).filter(index => index !== -1);


    const value = {
      activity_id: active?.id,
      completion_percentage: Math.round((partCount / totalCount) * 100),
      deployed_part_count: partCount,
      part_id: active?.target?.part_id,
      status: 1,
      total_part_count: totalCount,
      bom_per_tracker_type: trackerType,
      selectedPierIndices: selectedPierIndices,
      selectedTtIndices: selectedTtIndices,
    };

    setFinalData((prevData) => {
      const key = String(markData?.tracker_type_id);
      const existingIndex = prevData.findIndex((item) => Object.keys(item)[0] === key);

      if (existingIndex !== -1) {
        const updatedData = [...prevData];
        updatedData[existingIndex] = { [key]: value };
        return updatedData;
      } else {
        return [...prevData, { [key]: value }];
      }
    });
    setOpenSecondModal(false);
  };

  const handleSubmit = async () => {
    setLoader(true);

    const sections = convertSelectedRowsToOldFormat(selectedRow);
    const result = finalData?.flatMap(item => {
      return sections.flatMap(section => {
        const [, trackerRowIdStr, trackerTypeIdStr] = section?.split("-") || [];
        const trackerRowId = parseInt(trackerRowIdStr);
        const trackerTypeId = parseInt(trackerTypeIdStr);
        const trackerData = item?.[trackerTypeId];
        const partKey = `${partId}_${trackerTypeId}`;
        const partCount = partTrackerTypes[partKey];

        if (trackerData?.activity_id) {
          const tempData = findPierAndTtByTrackerRowId(bulkAllData, trackerRowId)

          const piers = tempData?.pier?.map((pier, index) => ({
            pier_id: pier.id,
            status: trackerData.selectedPierIndices?.includes(index) ? 1 : 0,
          })) || [];

          const torqueTubes = tempData?.tt?.map((tt, index) => ({
            torque_tube_id: tt.id,
            status: trackerData.selectedTtIndices?.includes(index) ? 1 : 0,
          })) || [];

          return {
            activity_id: trackerData.activity_id,
            block_id: trackerData.block_id,
            block_name: trackerData.block_name,
            bom_per_tracker_type: trackerData.bom_per_tracker_type,
            completion_percentage: trackerData.completion_percentage,
            deployed_part_count: trackerData.deployed_part_count,
            part_id: trackerData.part_id,
            status: trackerData.status,
            total_part_count: partCount,
            tracker_row_id: trackerRowId,
            tracker_type_id: trackerTypeId,
            laydown_id: bulkAllData?.piers?.[trackerRowId]?.[0]?.["laydown_id"] ? bulkAllData?.piers?.[trackerRowId]?.[0]?.["laydown_id"] : null,
            piers: piers,
            torque_tubes: torqueTubes
          };
        }

        return [];
      });
    });

    try {
      const res = await updateProgress(parseInt(params?.id), result);
      if (res) {
        await fetchCount(activityData);
        await setProgress(parseInt(params?.id));
        await setBlocks(parseInt(params?.id), activityData?.id);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
      setOpen(false)
      setSelectedRow({
        count: null,
        sections: {},
        trackerTypes: {}
      })
      setCurrent(false)
      setEditableDistributedRows([])
      setEditableinstalledRows([])
      setSection([])
      setTracker([])
      setPartCount([])
    }
  };

  return (
    <Box py={1}>
      <Card variant="outlined" sx={{ borderRadius: 1 }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" pb={2}>
            <Typography fontSize={18} fontWeight={600}>
              {title}
            </Typography>
            <Typography variant="span" fontSize={16} marginRight={2} color="#f16253" fontWeight={600} gutterBottom>{percentage}%</Typography>
          </Box>

          {loader ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
              <CircularProgress />
            </Box>
          ) : (
            <>
              {list.map((activity, index) => (
                <Box key={index}>
                  <Box
                    border={active.key === 'parent' && active.index === index ? '2px solid #f16253' : '1px solid #e2e8f0'}
                    borderRadius={1}
                    px={1}
                    py={0.5}
                    mb={1}
                    sx={{
                      cursor: 'pointer',
                      '&:hover': { boxShadow: 1 },
                    }}
                    onClick={() => handleClick('parent', index, activity.label, activity, activity?.id)}
                  >
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography fontSize={14} fontWeight={600} width="45%">
                        {index + 1}. {activity.label}
                      </Typography>
                      <Box width="50%" display="flex" alignItems="center" gap={2}>
                        <LinearProgress
                          variant="determinate"
                          value={activity.progress}
                          sx={{ height: 8, borderRadius: 1, flexGrow: 1, backgroundColor: '#fff2f1', '& .MuiLinearProgress-bar': { backgroundColor: roundDown(activity.progress) === 100 ? "#06b706" : '#f16253' } }}
                          color="inherit"
                        />
                        <Typography fontSize={14} fontWeight={600}>
                          {roundDown(activity.progress)}%
                        </Typography>
                      </Box>
                    </Box>
                    {active.key === 'parent' && active.index === index && checked && (
                      <Box py={2} px={2}>
                        <Box sx={{ display: "flex", justifyContent: "space-evenly", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
                          {getList(params).map((item, index) => {
                            const isInProgressOption = item === "in_progress";
                            const isDisabled = isInProgressOption || !selectPart?.length;
                            return <Box
                              sx={{
                                border: "1px solid #e0e0e0",
                                px: 3,
                                py: 0.5,
                                borderRadius: "20px",
                                backgroundColor: (current === item && selectPart?.length && !isInProgressOption ) ? "#4ade80" : selectPart?.length && isInProgressOption ? "white" : "e0e0e0",
                                color: (current === item && selectPart?.length && !isInProgressOption) ? "white" : "",
                                cursor: selectPart?.length && !isDisabled ? "pointer" : "not-allowed",

                              }}
                              fontSize={15}
                              key={index}
                              onClick={(e) => handleSetCurrent(e, item)}
                            >
                              {startCase(item)}
                            </Box>
                          })}
                        </Box>
                        <Button disabled={!current} loading={btnLoader} variant="contained" sx={{ width: "100%", mt: 2 }} onClick={(e) => handleClickApply(e, "parent_activity", activity)}>
                          Apply
                        </Button>
                      </Box>
                    )}
                  </Box>
                  {/* Children */}
                  {activity.children?.map((child, childIndex) => (
                    <Box
                      key={childIndex}
                      border={
                        active.label === activity.label &&
                          active.key === 'children' &&
                          active.index === childIndex
                          ? '2px solid #f16253'
                          : '1px solid #e2e8f0'
                      }
                      borderRadius={1}
                      px={1}
                      py={0.5}
                      mb={1}
                      sx={{
                        cursor: 'pointer',
                        '&:hover': { boxShadow: 1 },
                      }}
                      onClick={() =>
                        handleClick('children', childIndex, activity.label, activity, child?.id)
                      }
                    >
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography fontSize={14} width="45%">
                          {index + 1}.{childIndex + 1} {child.label}
                        </Typography>
                        <Box width="50%" display="flex" alignItems="center" gap={2}>
                          <LinearProgress
                            variant="determinate"
                            value={child.progress}
                            sx={{ height: 8, borderRadius: 1, flexGrow: 1, backgroundColor: '#fff2f1', '& .MuiLinearProgress-bar': { backgroundColor: roundDown(child?.progress) === 100 ? "#06b706" : '#f16253' } }}
                            color="inherit"
                          />
                          <Typography fontSize={14}>{roundDown(child.progress)}%</Typography>
                        </Box>
                      </Box>

                      {active.label === activity.label &&
                        active.key === 'children' &&
                        active.index === childIndex && (
                          <Box mt={1} display="flex" justifyContent="flex-end">
                            {loading ? (
                              <CircularProgress size={18} />
                            ) : (
                              <Typography fontSize={14} fontWeight={600}>
                                {data?.deployed_part_count?.[0]?.deployed_count || 0}{' '}
                                <span style={{ color: '#f16253' }}>out of</span>{' '}
                                {data?.total_part_count || 0} {getPartName(child?.part_id, partList)}
                              </Typography>
                            )}
                          </Box>
                        )}

                      {active.label === activity.label &&
                        active.key === 'children' &&
                        active.index === childIndex && checked && (
                          <Box py={2} px={2}>
                            <Box sx={{ display: "flex", justifyContent: "space-evenly", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
                              {getList(params).map((item, index) => {
                                return <Box
                                  sx={{
                                    border: "1px solid #e0e0e0",
                                    px: 3,
                                    py: 0.5,
                                    borderRadius: "20px",
                                    backgroundColor: (current === item && selectPart?.length) ? "#4ade80" : selectPart?.length ? "white" : "#e0e0e0",
                                    color: (current === item && selectPart?.length) ? "white" : "",
                                    cursor: selectPart?.length ? "pointer" : "not-allowed",
                                  }}
                                  fontSize={15}
                                  key={index}
                                  onClick={(e) => handleSetCurrent(e, item)}
                                >
                                  {startCase(item)}
                                </Box>
                              })}
                            </Box>
                            <Button disabled={!current} loading={btnLoader} variant="contained" sx={{ width: "100%", mt: 2 }} onClick={(e) => handleClickApply(e, "sub_activity", child)}>
                              Apply
                            </Button>
                          </Box>
                        )}
                    </Box>
                  ))}
                </Box>
              ))}
            </>
          )}
        </CardContent>
      </Card>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            width: "80vw",
            height: "80vh",
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" fontWeight={600}>{blockName}</Typography>
            <CloseIcon onClick={() => setOpen(false)} sx={{ cursor: "pointer" }} />
          </Box>
          <Typography fontSize={16} sx={{ mt: 0.5 }}>{selectedRow?.count} Trackers selected</Typography>
          <Typography fontSize={16} sx={{ mt: 0.5 }}>{active?.label} {">"} {active?.target?.label}</Typography>
          <TrackerTypeTable
            rows={selectedRow?.count ? filterTrackerTypes(Object?.keys(selectedRow?.trackerTypes), trackerList, selectedRow) : []}
            setOpenSecondModal={setOpenSecondModal}
            setMarkData={setMarkData}
            finalData={finalData}
            markData={markData}
            handleSubmit={handleSubmit}
            setPartCount={setPartCount}
            setTotalCount={setTotalCount}
            setSelectedPier={setSelectedPier}
            setSelectedTt={setSelectedTt}
            loader={load}
          />
        </Box>
      </Modal>

      <Modal
        open={openSecondModal}
        onClose={() => setOpenSecondModal(false)}
      >
        <Box sx={{
          width: "80vw",
          height: "90vh",
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 2,
          borderRadius: 2,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          overflow: "scroll"
        }}>
          <StepperForm
            data={markData}
            active={active}
            tableData={projectBom}
            selectedRow={convertSelectedRowsToOldFormat(selectedRow)}
            bomTrackerTypes={bomTrackerTypes}
            partCount={partCount}
            setPartCount={setPartCount}
            totalCount={totalCount}
            setTotalCount={setTotalCount}
            editableDistributedRows={editableDistributedRows}
            editableInstalledRows={editableInstalledRows}
            setEditableDistributedRows={setEditableDistributedRows}
            setEditableinstalledRows={setEditableinstalledRows}
            handleSave={handleSave}
            svgData={bulkAllData}
            pierlegends={pierlegends}
            selectedPier={selectedPier}
            setSelectedPier={setSelectedPier}
            selectedTt={selectedTt}
            setSelectedTt={setSelectedTt}
            finalData={finalData}
            currentTrackerRow={currentTrackerRow}
            setCurrentTrackerRow={setCurrentTrackerRow}
            setOpenSecondModal={setOpenSecondModal}
            currentProject={currentProject}
            flattenedTrackerData={flattenedTrackerData}
            flattenedNextTrackerData={flattenedNextTrackerData}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default CardComponent;